import React, { useCallback, useRef, useState, useEffect, useMemo } from "react";
import { connect } from "react-redux";
import {
    Column,
    DataGrid,
    Selection,
    Export,
    Sorting,
    Paging,
    Pager,
    Toolbar,
    Item,
    Editing,
    FilterRow,
    StateStoring,
    Lookup,
    ColumnChooser,
    ColumnChooserSearch
} from "devextreme-react/data-grid";
import DataSource from "devextreme/data/data_source";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { LoadPanel } from 'devextreme-react/load-panel';
import { SelectBox, DateBox } from "devextreme-react";
import axios from "axios";
import data from "../../../../../assets/apiRoutes.json";
import notify from 'devextreme/ui/notify';
import RenderSelectBoxCell from "../../../../../common/RenderCell";

function DetailsTab(props) {
    const accessToken = props?.oidc?.user?.access_token;
    const detailGrid = useRef(null);
    const [loadPanelVisible, setLoadPanelVisible] = useState(false);
    const [selectedItemKeys, setSelectedItemKeys] = useState([]);
    const gridKey = "A4B5C6D7-E8F9-4G0H-1I2J-3K4L5M6N7O8P";
    
    const position = { of: '#accordion' };

    const hideLoadPanel = useCallback(() => {
        setLoadPanelVisible(false);
    }, []);

    const loadState = useCallback(() => {
        return null; // Can be implemented later for state persistence
    }, []);

    const saveState = useCallback((state) => {
        // Can be implemented later for state persistence
    }, []);

    // DataSource for the grid
    const dataSource = useMemo(() => {
        if (!props.headerId || props.headerId === '00000000-0000-0000-0000-000000000000') {
            return new DataSource({
                store: [],
                key: "RowId"
            });
        }

        return new DataSource({
            store: createStore({
                key: "RowId",
                loadUrl: `${window._env_.REACT_APP_APIS}/${data.ItemKitDetail.GetItemKitDetail}`,
                insertUrl: `${window._env_.REACT_APP_APIS}/${data.ItemKitDetail.InsertItemKitDetail}`,
                updateUrl: `${window._env_.REACT_APP_APIS}/${data.ItemKitDetail.UpdateItemKitDetail}`,
                loadParams: {
                    HeaderId: props.headerId,
                    Module: "WM"
                },
                onBeforeSend: function (method, ajaxOptions) {
                    ajaxOptions.headers = {
                        Authorization: `Bearer ${accessToken}`,
                        access_token: accessToken,
                        'Content-Type': 'application/json'
                    };
                    
                    // Customize insert request
                    if (method === "insert") {
                        try {
                            // createStore sends form data with 'values' parameter
                            let valuesObj = {};
                            if (ajaxOptions.data && ajaxOptions.data.values) {
                                if (typeof ajaxOptions.data.values === 'string') {
                                    valuesObj = JSON.parse(ajaxOptions.data.values);
                                } else {
                                    valuesObj = ajaxOptions.data.values;
                                }
                            }
                            
                            // Transform to match our API format
                            const payload = {
                                RowId: '00000000-0000-0000-0000-000000000000',
                                RKittHeader: props.headerId,
                                RItem: valuesObj.RItem || valuesObj.ItemId || null,
                                Quantity: valuesObj.Quantity || 0,
                                Comment: valuesObj.Comment || null,
                                UserDefinedDate1: valuesObj.UserDefinedDate1 || null,
                                UserDefinedDate2: valuesObj.UserDefinedDate2 || null,
                                UserDefinedDate3: valuesObj.UserDefinedDate3 || null,
                                UserDefinedDate4: valuesObj.UserDefinedDate4 || null,
                                UserDefinedDate5: valuesObj.UserDefinedDate5 || null,
                                UserDefinedQuantity1: valuesObj.UserDefinedQuantity1 || 0,
                                UserDefinedQuantity2: valuesObj.UserDefinedQuantity2 || 0,
                                UserDefinedQuantity3: valuesObj.UserDefinedQuantity3 || 0,
                                UserDefinedQuantity4: valuesObj.UserDefinedQuantity4 || 0,
                                UserDefinedQuantity5: valuesObj.UserDefinedQuantity5 || 0,
                                UserDefinedCode1: valuesObj.userDefinedCode1 || valuesObj.UserDefinedCode1 || null,
                                UserDefinedCode2: valuesObj.userDefinedCode2 || valuesObj.UserDefinedCode2 || null,
                                UserDefinedCode3: valuesObj.userDefinedCode3 || valuesObj.UserDefinedCode3 || null,
                                UserDefinedCode4: valuesObj.userDefinedCode4 || valuesObj.UserDefinedCode4 || null,
                                UserDefinedCode5: valuesObj.userDefinedCode5 || valuesObj.UserDefinedCode5 || null
                            };
                            ajaxOptions.data = JSON.stringify(payload);
                        } catch (e) {
                            console.error("Error parsing insert values:", e);
                        }
                    }
                    
                    // Customize update request
                    if (method === "update") {
                        try {
                            // createStore sends form data with 'key' and 'values' parameters
                            let valuesObj = {};
                            let key = null;
                            
                            if (ajaxOptions.data) {
                                key = ajaxOptions.data.key;
                                if (ajaxOptions.data.values) {
                                    if (typeof ajaxOptions.data.values === 'string') {
                                        valuesObj = JSON.parse(ajaxOptions.data.values);
                                    } else {
                                        valuesObj = ajaxOptions.data.values;
                                    }
                                }
                            }
                            
                            // Transform to match our API format
                            const payload = {
                                RowId: key,
                                RKittHeader: props.headerId,
                                RItem: valuesObj.RItem !== undefined ? valuesObj.RItem : null,
                                Quantity: valuesObj.Quantity !== undefined ? valuesObj.Quantity : null,
                                Comment: valuesObj.Comment !== undefined ? valuesObj.Comment : null,
                                UserDefinedDate1: valuesObj.UserDefinedDate1 !== undefined ? valuesObj.UserDefinedDate1 : null,
                                UserDefinedDate2: valuesObj.UserDefinedDate2 !== undefined ? valuesObj.UserDefinedDate2 : null,
                                UserDefinedDate3: valuesObj.UserDefinedDate3 !== undefined ? valuesObj.UserDefinedDate3 : null,
                                UserDefinedDate4: valuesObj.UserDefinedDate4 !== undefined ? valuesObj.UserDefinedDate4 : null,
                                UserDefinedDate5: valuesObj.UserDefinedDate5 !== undefined ? valuesObj.UserDefinedDate5 : null,
                                UserDefinedQuantity1: valuesObj.UserDefinedQuantity1 !== undefined ? valuesObj.UserDefinedQuantity1 : null,
                                UserDefinedQuantity2: valuesObj.UserDefinedQuantity2 !== undefined ? valuesObj.UserDefinedQuantity2 : null,
                                UserDefinedQuantity3: valuesObj.UserDefinedQuantity3 !== undefined ? valuesObj.UserDefinedQuantity3 : null,
                                UserDefinedQuantity4: valuesObj.UserDefinedQuantity4 !== undefined ? valuesObj.UserDefinedQuantity4 : null,
                                UserDefinedQuantity5: valuesObj.UserDefinedQuantity5 !== undefined ? valuesObj.UserDefinedQuantity5 : null,
                                UserDefinedCode1: valuesObj.userDefinedCode1 !== undefined ? valuesObj.userDefinedCode1 : (valuesObj.UserDefinedCode1 !== undefined ? valuesObj.UserDefinedCode1 : null),
                                UserDefinedCode2: valuesObj.userDefinedCode2 !== undefined ? valuesObj.userDefinedCode2 : (valuesObj.UserDefinedCode2 !== undefined ? valuesObj.UserDefinedCode2 : null),
                                UserDefinedCode3: valuesObj.userDefinedCode3 !== undefined ? valuesObj.userDefinedCode3 : (valuesObj.UserDefinedCode3 !== undefined ? valuesObj.UserDefinedCode3 : null),
                                UserDefinedCode4: valuesObj.userDefinedCode4 !== undefined ? valuesObj.userDefinedCode4 : (valuesObj.UserDefinedCode4 !== undefined ? valuesObj.UserDefinedCode4 : null),
                                UserDefinedCode5: valuesObj.userDefinedCode5 !== undefined ? valuesObj.userDefinedCode5 : (valuesObj.UserDefinedCode5 !== undefined ? valuesObj.UserDefinedCode5 : null)
                            };
                            ajaxOptions.data = JSON.stringify(payload);
                        } catch (e) {
                            console.error("Error parsing update values:", e);
                        }
                    }
                },
                onInserted: function(e) {
                    // Handle successful insert - e contains the inserted data
                    // The grid will automatically update with the response data
                    notify("Item Kit Detail inserted successfully.", "success", 3000);
                    // Refresh to get the latest data including ItemCode, Description1, Description2
                    setTimeout(() => {
                        if (detailGrid.current?.instance) {
                            detailGrid.current.instance().refresh();
                        }
                    }, 100);
                },
                onUpdated: function(key, updatedValues) {
                    // Handle successful update - updatedValues contains the updated data
                    // The grid will automatically update with the response data
                    notify("Item Kit Detail updated successfully.", "success", 3000);
                    // Refresh to get the latest data including ItemCode, Description1, Description2
                    setTimeout(() => {
                        if (detailGrid.current?.instance) {
                            detailGrid.current.instance().refresh();
                        }
                    }, 100);
                },
                onInsertError: function(error) {
                    const message = error?.message || error?.responseJSON?.message || "Failed to insert Item Kit Detail.";
                    notify(message, "error", 5000);
                },
                onUpdateError: function(error) {
                    const message = error?.message || error?.responseJSON?.message || "Failed to update Item Kit Detail.";
                    notify(message, "error", 5000);
                }
            }),
            key: "RowId",
            paginate: false
        });
    }, [props.headerId, accessToken]);

    const onSelectionChanged = useCallback((e) => {
        setSelectedItemKeys(e.selectedRowKeys);
    }, []);

    const onInitNewRow = useCallback((e) => {
        e.data.RowId = '00000000-0000-0000-0000-000000000000';
        e.data.rKittHeader = props.headerId;
        e.data.RItem = null;
        e.data.ItemCode = '';
        e.data.Description1 = '';
        e.data.Description2 = '';
        e.data.Quantity = 0;
        e.data.Comment = '';
        e.data.UserDefinedDate1 = null;
        e.data.UserDefinedDate2 = null;
        e.data.UserDefinedDate3 = null;
        e.data.UserDefinedDate4 = null;
        e.data.UserDefinedDate5 = null;
        e.data.UserDefinedQuantity1 = 0;
        e.data.UserDefinedQuantity2 = 0;
        e.data.UserDefinedQuantity3 = 0;
        e.data.UserDefinedQuantity4 = 0;
        e.data.UserDefinedQuantity5 = 0;
        e.data.UserDefinedCode1 = '';
        e.data.UserDefinedCode2 = '';
        e.data.UserDefinedCode3 = '';
        e.data.UserDefinedCode4 = '';
        e.data.UserDefinedCode5 = '';
    }, [props.headerId]);

    // Note: onRowInserted and onRowUpdating are no longer needed for cell mode
    // The store's insertUrl and updateUrl handle the API calls automatically
    // We keep onRowInserted and onRowUpdated for any additional logic if needed
    const onRowInserted = useCallback((e) => {
        // Additional logic after insert if needed
        if (detailGrid.current?.instance) {
            detailGrid.current.instance().selectRows([e.key], true);
        }
    }, []);

    const onRowUpdating = useCallback((e) => {
        // Additional validation or logic before update if needed
        // The actual update is handled by the store's updateUrl
    }, []);

    const onRowUpdated = useCallback(() => {
        if (detailGrid.current?.instance) {
            detailGrid.current.instance().refresh();
        }
    }, []);

    const onEditingStart = useCallback((e) => {
        if (e.key != null && e.key != undefined && !detailGrid.current?.instance()?.isRowSelected(e.key)) {
            detailGrid.current.instance().selectRows([e.key], false);
        }
    }, []);

    const onEditCanceled = useCallback(() => {
        // Handle edit cancellation if needed
    }, []);

    const onContentReady = useCallback((e) => {
        if (!e.component._hasLoaded) {
            e.component._hasLoaded = true;
            var selection = e.component.getSelectedRowKeys();
            if (selection.length == 0) {
                e.component.selectRowsByIndexes([0]);
            }
        }
    }, []);

    return (
        <div>
            <LoadPanel
                shadingColor="rgba(0,0,0,0.4)"
                position={position}
                onHiding={hideLoadPanel}
                visible={loadPanelVisible}
                showIndicator={true}
                shading={true}
                showPane={true}
                hideOnOutsideClick={false}
            />
            <DataGrid
                dataSource={dataSource}
                ref={detailGrid}
                selectedRowKeys={selectedItemKeys}
                showBorders={true}
                rowAlternationEnabled={true}
                allowColumnReordering={true}
                allowColumnResizing={true}
                columnAutoWidth={true}
                onSelectionChanged={onSelectionChanged}
                onInitNewRow={onInitNewRow}
                onRowInserted={onRowInserted}
                onRowUpdating={onRowUpdating}
                onRowUpdated={onRowUpdated}
                onEditingStart={onEditingStart}
                onEditCanceled={onEditCanceled}
                onContentReady={onContentReady}
                height="80vh"
            >
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Selection mode="single" />
                <Export enabled={true} allowExportSelectedData={true} />
                <Editing
                    mode="cell"
                    refreshMode="repaint"
                    allowAdding={true}
                    allowUpdating={true}
                    allowDeleting={false}
                    newRowPosition="last"
                />
                <FilterRow visible={true} />
                <Sorting mode="none" />
                <Paging enabled={false} />
                
                <Column dataField="RowId" caption="Row ID" visible={false} />
                <Column dataField="rKittHeader" caption="Header ID" visible={false} />
                <Column dataField="RItem" caption="Item ID" visible={false} />
                <Column 
                    dataField="ItemCode" 
                    caption="Item" 
                    allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Item.GetItems}`,
                            loadParams: {
                                customerIdentity: props.customerId || null
                            },
                            key: "id",
                            displayExpr: "name",
                            valueExpr: "id",
                            accessToken: accessToken,
                            defaultValue: cellElement.data.RItem,
                            sort: [{ selector: "name", desc: false }],
                            onValueChangeCallback: async (value, text, e) => {
                                cellElement.setValue({ value, text });
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.ItemCode = newValue.text;
                        rowData.RItem = newValue.value;
                    }}
                />
                <Column dataField="Description1" caption="Description 1" allowEditing={false} />
                <Column dataField="Description2" caption="Description 2" allowEditing={false} />
                <Column 
                    dataField="Quantity" 
                    caption="Quantity" 
                    dataType="number"
                    format="#,##0.00"
                    allowSorting={false}
                />
                <Column 
                    dataField="Comment" 
                    caption="Comment" 
                    dataType="string"
                    allowSorting={false}
                />
                <Column 
                    dataField="UserDefinedDate1" 
                    caption="Date 1" 
                    dataType="date"
                    format="MM/dd/yyyy"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedDate2" 
                    caption="Date 2" 
                    dataType="date"
                    format="MM/dd/yyyy"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedDate3" 
                    caption="Date 3" 
                    dataType="date"
                    format="MM/dd/yyyy"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedDate4" 
                    caption="Date 4" 
                    dataType="date"
                    format="MM/dd/yyyy"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedDate5" 
                    caption="Date 5" 
                    dataType="date"
                    format="MM/dd/yyyy"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedQuantity1" 
                    caption="Quantity 1" 
                    dataType="number"
                    format="#,##0.00"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedQuantity2" 
                    caption="Quantity 2" 
                    dataType="number"
                    format="#,##0.00"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedQuantity3" 
                    caption="Quantity 3" 
                    dataType="number"
                    format="#,##0.00"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedQuantity4" 
                    caption="Quantity 4" 
                    dataType="number"
                    format="#,##0.00"
                    allowSorting={false}
                    visible={false} 
                />
                <Column 
                    dataField="UserDefinedQuantity5" 
                    caption="Quantity 5" 
                    dataType="number"
                    format="#,##0.00"
                    allowSorting={false}
                    visible={false} 
                />
                <Column  visible={false}   dataField="UserDefinedCode1" caption="Code1" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return 'B1';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.UserDefinedCode1,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.UserDefinedCode1 = newValue.text;
                    }}
                />
                <Column  visible={false}  dataField="UserDefinedCode2" caption="Code2" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return 'B2';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.UserDefinedCode2,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.UserDefinedCode2 = newValue.text;
                    }}
                />
                <Column  visible={false}  dataField="UserDefinedCode3" caption="Code3" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return 'B3';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.UserDefinedCode3,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.UserDefinedCode3 = newValue.text;
                    }}
                />
                <Column  visible={false}  dataField="UserDefinedCode4" caption="Code4" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return 'B4';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.UserDefinedCode4,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.UserDefinedCode4 = newValue.text;
                    }}
                />
                <Column  visible={false}  dataField="UserDefinedCode5" caption="Code5" dataType="string" allowSorting={false}
                    editCellRender={(cellElement) =>
                        RenderSelectBoxCell({
                            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMLookup.GetCodes}`,
                            loadParams: {
                                codeType: function () {
                                    return 'B5';
                                }
                            },
                            key: "name",
                            displayExpr: "name",
                            valueExpr: "name",
                            accessToken: accessToken,
                            sort: [{ selector: "name", desc: false }],
                            defaultValue: cellElement.data.UserDefinedCode5,
                            onValueChangeCallback: (value, text) => {
                                cellElement.setValue(({ value, text }));
                            },
                        })
                    }
                    setCellValue={(rowData, newValue) => {
                        rowData.UserDefinedCode5 = newValue.text;
                    }}
                />
                <Toolbar>
                    <Item name="addRowButton" />
                    <Item name="saveButton" />
                    <Item name="revertButton" />
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(DetailsTab);

